import { createSelector } from 'reselect';

const customersStateSelector = (state) => state.pendingCustomers;
const selectById = (state, itemId) => itemId;

export const customersSelector = createSelector(
  [customersStateSelector],
  (customers) => customers.items
);

export const customersListSelector = createSelector(
  [customersSelector],
  (customers) =>
    customers.map((customer) => ({
      name: customer.businessName,
      _id: customer._id,
    }))
);

export const customerByIdSelector = createSelector(
  [customersSelector, selectById],
  (customers, _id) => {
    const customer = customers.find((item) => _id === item._id);
    if (!customer) return null;
    return customer;
  }
);

export const pendingCustomersIsLoadingSelector = createSelector(
  [customersStateSelector],
  (customers) => customers.isLoading
);

export const customersCountSelector = createSelector(
  [customersStateSelector],
  (customers) => customers.count
);

/* export const searchValueSelector = createSelector(
  [customersStateSelector],
  (customers) => customers.searchValue
);
 */
